module.exports = __webpack_public_path__ + "img/propertysystem2.6c2b2a87.png";